import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsBoardObjectBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The board object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the board.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description: 'Time at which the board was created, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description:
                  'Whether or not the board is set as private in the administrative settings.',
                heading: 'isPrivate',
                subheading: 'boolean',
              },
              {
                description: "The board's name.",
                heading: 'name',
                subheading: 'string',
              },
              {
                description:
                  'The number of non-deleted posts associated with the board. This number includes posts that are marked as closed or complete.',
                heading: 'postCount',
                subheading: 'number',
              },
              {
                description:
                  'Whether or not comments left on posts can be viewed by other end-users.',
                heading: 'privateComments',
                subheading: 'boolean',
              },
              {
                description: "The URL to the board's page.",
                heading: 'url',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example board object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba1234",
  "created": "2017-07-15T22:11:00.000Z",
  "name": "Feature Requests",
  "postCount": 123,
  "url": "https://your-company.canny.io/admin/board/feature-requests"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
